import { render, staticRenderFns } from "./claimDtlInsure2.vue?vue&type=template&id=756f4dfc&scoped=true&"
import script from "./claimDtlInsure2.vue?vue&type=script&lang=js&"
export * from "./claimDtlInsure2.vue?vue&type=script&lang=js&"
import style0 from "./claimDtlInsure2.vue?vue&type=style&index=0&id=756f4dfc&prod&lang=scss&scoped=true&"
import style1 from "./claimDtlInsure2.vue?vue&type=style&index=1&id=756f4dfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f4dfc",
  null
  
)

export default component.exports